import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { thunk } from 'redux-thunk';
import { api } from "./api";
import { firebaseApi } from "./firebaseApi";
import rootReducer from "./root.reducer";
import { migrations } from "./persistMigrations";
const persistConfig = {
  key: 'root',
  // changes in store update version number too
  version: 2,
  storage,
  whitelist: ['campaignSlice', 'commonSlice', 'dashboardSlice',"wishlistSlice","communityPostSlice"],
  migrate:createMigrate(migrations,{debug:false})
}
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    api.middleware,
    firebaseApi.middleware,
    thunk//, logger
  ],
});

export const persistor = persistStore(store);
setupListeners(store.dispatch);